export default {

  config: null,

  requestUrl(url) {
    return `${this.config.API}${url}`;
  },
};



// WEBPACK FOOTER //
// ./src/util/HttpResource.js